import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, custom }: Theme) => ({
  root: {
    fontSize: 14,
    color: custom.grey[3],
    lineHeight: 1.43,
    transformOrigin: 'left top',
    transform: 'scale(1) translate3d(0, 30px, 0)',
    transition: '200ms ease all',
    fontWeight: 600,
    marginBottom: 10,
  },
  shrink: {
    fontSize: 16,
  },
  floated: {
    fontWeight: 'bold',
    color: custom.grey[3],
    '&.focused': {},
    '&.transform': {
      transform: 'translate3d(0, 0, 0)',
    },
  },
  focused: {
    color: palette.primary.main,
  },
  disabled: {
    color: 'rgba(0, 0, 0, 0.38)',
  },
  notFloating: {
    transform: 'none',
    fontWeight: 600,
  },
  filled: {},
  floating: {
    marginBottom: 5,
  },
  error: {},
}));
